module.exports = __webpack_public_path__ + "static/media/logo.c2eab03e.png";